"use client";
import Page from '@/pages/Contact';
export default Page;